module.exports = __webpack_public_path__ + "img/earnie@2x.e0679c31.png";